<template>
  <div class="content block-el">
    <template v-if="!loading">
      <PageHeader :title="$tc('app.edit')">
        <template #actions>
          <ButtonComponent @click="$refs['update-agent'].submit()" :loading="updating">
            {{ $tc('app.save') }}
          </ButtonComponent>
        </template>
      </PageHeader>
      <div class="page-content container-fluid">
        <FormComponent ref="update-agent" @submit="update">
          <div class="row">
            <div class="col-6">
              <CardComponent variant="tertiary">
                <template #header>
                  {{ $tc('app.general') }}
                </template>
                <InputComponent v-model="agent.name" :label="$tc('app.name', 1)" required type="text" :placeholder="$tc('app.name', 1)" />
                <hr class="dashed " />
              </CardComponent>
            </div>
            <div class="col-6">
              <CardComponent variant="tertiary">
                <template #header>
                  {{ $tc('rcs.set_fallback_mechanism') }}
                </template>
                <p class="card-text">{{ $tc('rcs.fallback_description') }}</p>
                <CheckboxComponent v-model="agent.enabled_fallback" :label="$tc('rcs.enable_fallback')" />
                <template v-if="agent.enabled_fallback">
                  <SelectComponent
                    v-if="shortCodes.length >= 1"
                    :options="shortCodes"
                    v-model="agent.sms_sender_id"
                    valueField="id"
                    textField="name"
                    :required="true"
                    :label="$tc('app.sender')"
                  ></SelectComponent>
                  <div v-else class="container">
                    <div class="row" style="gap: 30px;">
                      <div class="col-2 animated-background h-30 mb-5"></div>
                      <div class="col-4 animated-background h-30 mb-5"></div>
                    </div>
                  </div>
                </template>
              </CardComponent>
            </div>
          </div>
        </FormComponent>
      </div>
    </template>
    <div v-else class="static qt-block-ui" style="padding: 120px" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import Tab from '@/directives/Tab';
import PageHeader from '@/components/PageHeader.vue';
import ProviderService from '@/services/admin/provider.service';
import FormComponent from '@/components/form/FormComponent.vue';
import CardComponent from '@/components/CardComponent.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';
import SmsService from '@/services/sms.service';
import { mask } from 'vue-the-mask';
import CheckboxComponent from '@/components/form/CheckboxComponent.vue';
import SelectComponent from '@/components/form/SelectComponent.vue';

export default {
  name: 'EditAgent',
  components: {
    PageHeader,
    FormComponent,
    CardComponent,
    InputComponent,
    ButtonComponent,
    CheckboxComponent,
    SelectComponent,
  },
  directives: {
    Tab,
    mask,
  },
  data() {
    return {
      loading: true,
      fetched: false,
      isSending: false,
      shortCodes: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 4,
        masked: false,
      },
      updating: false,
      fallback_enabled: false,
      form: {},
      agent: {},
      searching: false,
      pages: 1,
    };
  },
  created() {
    this.fetchAgent();
    this.fetchShortCodes();
  },
  methods: {
    fetchAgent() {
      this.loading = true;
      this.$store
        .dispatch('fetchRcsAgent', this.$route.params.id)
        .then((response) => {
          this.agent = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchShortCodes() {
      SmsService.getAccountShortCodes().then(
        (shortCodes) => {
          this.shortCodes = shortCodes;
          if (shortCodes) {
            this.form.shortCodeId = shortCodes[0].id;
          }
        },
        (error) => {
          this.content = error;
        },
      );
    },
    update() {
      this.updating = true;
      this.$store
        .dispatch('updateRcsAgent', this.agent)
        .then(
          (response) => {
            this.agent = response;
            this.$toast.show({
              title: this.$t('generic-str.success'),
              content: this.$t('adm-component.supp-updated'),
              type: 'success',
            });
          },
          (error) => {
            this.$toast.show({
              title: this.$t('app.error'),
              content: this.$t('adm-component.supp-not-updated'),
              type: 'danger',
            });
          },
        )
        .finally(() => {
          this.updating = false;
        });
    },
  },
};
</script>
